import { GoalIcon, AssistIcon } from '@/common/assets';
import { PlayerOnPitchStats } from '@/common/constants';
import type { PlayerOnPitchStatsType } from '@/common/types';
import Jersey from '../Jersey/Jersey';
import { type PlayerOnPitchProps } from './PlayerOnPitch.types';
import Glow from './Glow';
import PlayerText from './PlayerText';
import Shield from './Shield';

export default function PlayerOnPitch({
  jerseySrc,
  playerName,
  goals,
  assists,
  activeStat = PlayerOnPitchStats.NONE,
  className = '',
}: PlayerOnPitchProps) {
  const goalModes: PlayerOnPitchStatsType[] = [PlayerOnPitchStats.GOALS, PlayerOnPitchStats.BOTH];
  const assistModes: PlayerOnPitchStatsType[] = [
    PlayerOnPitchStats.ASSISTS,
    PlayerOnPitchStats.BOTH,
  ];
  const showGoals = goals > 0 && goalModes.includes(activeStat);
  const showAssists = assists > 0 && assistModes.includes(activeStat);
  const showStatsRow = showGoals || showAssists;

  return (
    <div className={`relative isolate shrink-0 h-[83px] w-[72px] ${className}`}>
      <Shield />
      <div className="absolute left-[16px] top-0 z-1 flex h-[40px] w-[40px] shrink-0 items-center justify-center mask-(--background-image-player-on-pitch-jersey-mask) [-webkit-mask-image:var(--background-image-player-on-pitch-jersey-mask)]">
        <Jersey jerseySrc={jerseySrc} size={40} />
      </div>
      <Glow />
      <div className="absolute left-0 top-[31px] z-3 flex w-full flex-col items-center gap-1 px-0">
        <PlayerText playerName={playerName} />
        {showStatsRow && (
          <div className="flex h-[20px] items-center gap-1 text-pmw-label-primary-dark">
            {showGoals && (
              <div className="flex items-center gap-0.5">
                <GoalIcon className="h-[12px] w-[12px] shrink-0" />
                <span className="font-robotoMedium text-[14px] font-medium leading-[20px] tabular-nums">
                  {goals}
                </span>
              </div>
            )}
            {showAssists && (
              <div className="flex items-center gap-0.5">
                <AssistIcon className="h-[7.5px] w-[12px] shrink-0" />
                <span className="font-robotoMedium text-[14px] font-medium leading-[20px] tabular-nums">
                  {assists}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
